import { keyArgsForPagination, mergeForPagination } from "./modules/utils";

const ACLPermissionTypePolicy = {
  ACLPermission: {
    keyFields: ({ uid }) => uid,
    fields: {
      enabledUsersV2: {
        keyArgs: args => {
          if (args) {
            return keyArgsForPagination(args);
          }
        },
        merge: (existing = {}, incoming = {}, { readField, args }) => {
          if (args) {
            return mergeForPagination({
              existing,
              incoming,
              readField,
              filters: args,
            });
          }
          return incoming;
        },
      },
    },
  },
};

export default ACLPermissionTypePolicy;
